import React, { useEffect, useState } from "react";

//Import Breadcrumb
import { Container } from "reactstrap";
import "react-toastify/dist/ReactToastify.css";

import { toast } from "react-toastify";
import { Star } from "lucide-react";

import { SingleReview, UpdateReview } from "../../apis/Reviews";
import { Button } from "../../components/shared/button";
import { Link, useParams } from "react-router-dom";

const EditReview = () => {
  const [review, setReview] = useState({
    reviewId: "",
    description: "",
    rating: "",
  });
  const [description, setDescription] = useState("");
  const [rating, setRating] = useState("0");
  const { reviewId } = useParams(); // Extract reviewId from the URL

  const fetchReview = async (reviewId) => {
    try {
      const response = await SingleReview(reviewId); // Fetch the review by reviewId
      if (response.success) {
        const review = response.data.review;
        setReview(review);
        setDescription(review.description);
        setRating(review.rating);
      } else {
        toast.error("Failed to fetch review. Please try again later.");
      }
    } catch (error) {
      toast.error("Failed to fetch review. Please try again later.");
    }
  };

  useEffect(() => {
    if (reviewId) fetchReview(reviewId);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [reviewId]);

  const handleUpdate = async () => {
    try {
      if (!description) {
        toast.warning("Please enter review content.");
        return;
      }
      if (parseInt(rating) === 0) {
        toast.warning("Please select a rating.");
        return;
      }
      if (rating === review.rating && description === review.description) {
        toast.warning("No changes detected.");
        return;
      }
      const response = await UpdateReview(reviewId, description, rating);
      if (response.success) {
        setReview({
          ...review,
          description,
          rating,
        });
        toast.success("Review updated successfully.");
      } else {
        toast.error("Failed to update review. Please try again later.");
      }
    } catch (error) {
      toast.error("Failed to update review. Please try again later.");
    }
  };

  return (
    <React.Fragment>
      <div className="page-content">
      <Container
        //  h-[calc(100vh-130px)]
        className="px-0 dark:bg-darkBg1 dark:text-[#c7d8eb]"
        fluid
      >
        <div className="p-6 flex flex-col gap-6 ">
          <h1 className="text-2xl dark:text-[#c7d8eb]">Edit Review</h1>
          <div className="lg:flex flex-col gap-6">
            <div className="w-full flex justify-end">
              <Link
                to={"/reviews"}
                className="rounded-md border border-primary font-semibold text-primary py-2 px-4 mb-2"
                sec
              >
                Go Back
              </Link>
            </div>
            <div className="flex flex-col gap-4 px-2 py-4 lg:border rounded-lg border-gray-400 dark:border-white/50">
              <div className="flex flex-col md:flex-row gap-3">
                <h4 className="p-2 dark:text-white text-base min-w-28 lg:text-lg font-normal lg:min-w-52">
                  Review content
                </h4>
                <textarea
                  value={description}
                  onChange={(e) => setDescription(e.target.value)}
                  className="p-3 min-h-28 w-full rounded-md border border-gray-400 dark:border-white/50 dark:bg-darkBg1"
                  placeholder="Write review content..."
                />
              </div>
              <div className="flex flex-col md:flex-row gap-3">
                <h4 className="p-2 dark:text-white text-base min-w-28 lg:text-lg font-normal lg:min-w-52">
                  Overall rating
                </h4>
                <div className="flex gap-0.5">
                  {Array.from(Array(5), (e, i) => {
                    return (
                      <Star
                        key={i}
                        onClick={() => setRating((i + 1).toString())}
                        className={`${
                          parseInt(rating) >= i + 1
                            ? "fill-primaryColor text-primaryColor"
                            : "fill-gray-400 text-gray-400"
                        } cursor-pointer`}
                        size={30}
                      />
                    );
                  })}
                </div>
              </div>
              <div className="w-full flex justify-end">
                <Button
                  onClick={handleUpdate}
                  className="font-semibold text-white"
                >
                  Submit
                </Button>
              </div>
            </div>
          </div>
        </div>
      </Container>
      </div>
    </React.Fragment>
  );
};

export default EditReview;
